import React, { useEffect, useState } from "react";
import SpecialtyDropdown from "../../shared/SpecialtyDropdown";
import Npi from "../../shared/NPI/NPI";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import { stateCodeArray } from "../../../services/fakeDB/ListUser";
import $ from "jquery";

let o = {
  AdminCount: 0,
  CredentialText: "",
  DomainBox: "",
  DomainId: 0,
  DomainName: null,
  ExternalId: "",
  IDs: [],
  Id: null,
  IsCertAddress: true,
  IsEpicOrganization: false,
  KeepMDN: false,
  NPI: "",
  OrgEmailCount: 0,
  OrganizationKind: null,
  OrganizationName: "",
  OrganizationType: "",
  OutOfNetwork: false,
  ParentOrg: "",
  ParentOrganizationId: null,
  ParentOrganizationName: null,
  Specialties: [],
  Addresse: {
    FirstLine: "",
    SecondLine: "",
    City: "",
    State: "",
    County: "",
    PostalCode: "",
    Country: "",
    Phone: "",
    PhoneExt: "",
    Fax: "",
    FaxExt: "",
    AddressType: 0,
  },
  SubOrgCount: 0,
  UserCount: 0,
  UserEmailCount: 0,
  VendorId: 0,
  VendorVal: "",
  XDRDoNOTGenerateXDM: false,
  XDREnabled: false,
  xdrConfig: {
    Id: null,
    IsValid: false,
    OrganizationId: null,
    UseConfigFile: false,
    EndpointName: "",
    EndpointAddress: "",
    ClientCertificate: false,
    ClientCertificateFindValue: "",
    SchemaValidatorOn: false,
    SchemaValidateRequest: false,
    SchemaValidateResponse: false,
    MDNForward: false,
  },
  AllowTwoFactor: false,
  ApplicationAccessXDR: false,
  ApplicationAccessENS: false,
  specializationCode: "",
  TwoFactorauth: false,
  EmailForwardingType: 0,
  DirectRoute: false,
  AdvancedDirectRoute: false,
  ShareDirectoryListing: false,
};
var resetData = o;

const RegistrationOrgForm = () => {
  const navigate = useNavigate();
  const {
    userToken,
    userRole,
    customerObj,
    XdrArr,
    setXDRArr,
    sharedObject,
    SetSharedObject,
    userSession,
  } = useUserStore((state) => ({
    userToken: state.userToken,
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    customerObj: state.customerObj,
    XdrArr: state.XdrArr,
    setXDRArr: state.setXDRArr,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
  }));
  const [processing, SetProcessing] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [answers, setAnswers] = useState(o);
  const [orgValues, SetOrgValues] = useState([]);
  const [custObject, SetCustObject] = useState([]);
  const [orgObject, SetOrgObject] = useState([]);
  const [customerPermissionsObj, SetCustomerPermissionsObj] = useState({});
  const [ParentXDRObj, SetParentXDRObj] = useState(false);
  const [noPermissions, SetNoPermissions] = useState(true);
  const [specialtiesFlag, SetspecialtiesFlag] = useState(false);
  const setAnswer = async (questionId, answer, chck) => {
    if (chck) {
      let obj = { ...answers };
      let add = answers.Addresse;
      add[questionId] = answer;
      obj.Addresse = add;
      await setAnswers(obj);
    } else {
      await setAnswers({ ...answers, [questionId]: answer });
    }
  };

  useEffect(() => {
    const resetAsync = async () => {
      await ResetData();
    };
    if (sharedObject.AddOrgFlag === true) {
      resetAsync();
      SetSharedObject("AddOrgFlag", false);
    }
    const buildXDR = async (ob) => {
      await setAnswers({
        ...answers,
        //XDREnabled: ob.ApplicationAccessXDR,
        //ApplicationAccessXDR: ob.ApplicationAccessXDR,
        xdrConfig: ob.xdrConfig,
        OutboundXDRConfigName: ob.OutboundXDRConfigName,
        ParentOrg: ob.ParentOrg,
      });
    };
    buildXDR(ParentXDRObj);
    /*return () => {
      ResetData();
      SetCustomerPermissionsObj({});
      SetspecialtiesFlag(false);
      SetSharedObject("xdrAdded", false);
      SetSharedObject("orgActionObj", {});
    };*/
  }, [ParentXDRObj]);

  useEffect(() => {
    const resetAsync = async () => {
      await ResetData();
    };
    if (sharedObject.AddOrgFlag === true) {
      resetAsync();
      SetSharedObject("AddOrgFlag", false);
    }
    const getOrgVals = async (val) => {
      let cust = null;
      if (val.Type === "top") {
        let temp = [];
        for (let el of sharedObject.vendorsObj) {
          el.show = true;
          temp.push(el);
          if (el.id === parseInt(val.VendorId)) {
            let vl = el.baseDomainId + "-" + el.id;
            getVendorsDomains(vl, el.name);
          }
        }
        SetCustObject(temp);
      } else {
        if (userRole !== "SES ADMINISTRATOR") {
          let vl = userSession.vendor_id;
          let custTemp = {};
          for (let el of sharedObject.vendorsObj) {
            if (parseInt(vl) === el.id) {
              custTemp = el;
            }
          }
          cust = custTemp;
        } else {
          cust = sharedObject.CustomerPermissionsObj;
        }
      }
      if (
        cust.emailForwardingType === 0 &&
        cust.twoFactorAuth === false &&
        cust.applicationAccessXDR === false &&
        cust.applicationAccessENS === false &&
        cust.directorySharing === false
      ) {
        await SetNoPermissions(true);
      } else {
        await SetNoPermissions(false);
      }

      let chck = false;
      let tempOrg = [];
      for (let el of sharedObject.getOrgsObj) {
        if (userRole !== "SES ADMINISTRATOR") {
          el.vendorId = userSession.vendor_id;
        }
        el.show = true;
        tempOrg.push(el);
      }
      SetOrgObject(tempOrg);
      getXDREndPoints();
      if (sharedObject.orgActionObj) {
        let org = sharedObject.orgActionObj;
        let vId =
          userRole !== "SES ADMINISTRATOR"
            ? userSession.vendor_id
            : org.VendorId;
        var o = "";
        if (org.name) {
          o = `${org.name}~${org.id}~${vId}`;
        } else {
          o = `${org.organizationName}~${org.id}~${vId}`;
        }
        await setAnswers({ ...answers, ParentOrg: o });
        if (val.Type === "sub") {
          GetDomainsByOrg(o, val.domainName);
        }
      }
    };
    let obj = sharedObject.orgActionObj;
    if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
      getOrgVals(obj);
    } else {
      let tempOrg = [];
      for (let el of sharedObject.getOrgsObj) {
        if (userRole !== "SES ADMINISTRATOR") {
          el.vendorId = userSession.vendor_id;
        }
        el.show = true;
        tempOrg.push(el);
      }
      SetOrgObject(tempOrg);
      let temp = [];
      for (let el of sharedObject.vendorsObj) {
        el.show = true;
        temp.push(el);
      }
      SetCustObject(temp);
    }
    SetSharedObject("selectedXdrSettiingObj", {});
    if (userRole !== "SES ADMINISTRATOR" && userRole !== "ADMINISTRATOR") {
      setAnswer(
        "VendorVal",
        userSession.domain_id + "-" + userSession.vendor_id,
        false
      );
    }
    SetspecialtiesFlag(false);
    if (sharedObject?.xdrAdded) {
      GetXdrConfig(sharedObject.xdrAdded);
    }
    return () => {
      ResetData();
      SetCustomerPermissionsObj({});
      SetspecialtiesFlag(false);
      SetSharedObject("xdrAdded", false);
      SetSharedObject("orgActionObj", {});
    };
  }, []);

  const ResetData = async () => {
    let AddresseObj = {
      FirstLine: "",
      SecondLine: "",
      City: "",
      State: "",
      County: "",
      PostalCode: "",
      Country: "",
      Phone: "",
      PhoneExt: "",
      Fax: "",
      FaxExt: "",
      AddressType: 0,
    };
    await setAnswers({ ...o, Addresse: AddresseObj });
    resetData = { ...o, Addresse: AddresseObj };
  };
  const getXDREndPoints = async () => {
    SetProcessing(true);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      await setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const CheckSpecialty = () => {
    let flag =
      isEmpty(sharedObject.specialties.Code) &&
      (!isEmpty(sharedObject.specialties.Type) ||
        !isEmpty(sharedObject.specialties.Classification));
    return flag;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const [colorMsg, SetColorMsg] = useState("danger");
  const SubmitOrgRegistration = async () => {
    SetFrmSubmFlag(true);
    SetErrMsg(false);
    SetErrCreateMsg(false);
    SetspecialtiesFlag(false);
    if (!answers.OrganizationName) {
      document.getElementById("OrganizationName").scrollIntoView();
      document.getElementById("OrganizationName").focus();
      return;
    } else if (!answers.ParentOrg && customerObj.Type === "sub") {
      document.getElementById("ParentOrg").scrollIntoView();
      document.getElementById("ParentOrg").focus();
      return;
    } else if (!answers.VendorVal && customerObj.Type === "top") {
      document.getElementById("VendorVal").scrollIntoView();
      document.getElementById("VendorVal").focus();
      return;
    } else if (!answers.DomainBox && userRole === "SES ADMINISTRATOR") {
      document.getElementById("DomainBox").scrollIntoView();
      document.getElementById("DomainBox").focus();
      return;
    } else if (
      answers.OrganizationKind === null ||
      answers.OrganizationKind === undefined
    ) {
      document.getElementById("OrganizationKind").scrollIntoView();
      document.getElementById("OrganizationKind").focus();
      return;
    } else if (!answers.Addresse.FirstLine) {
      document.getElementById("FirstLine").scrollIntoView();
      document.getElementById("FirstLine").focus();
      return;
    } else if (!answers.Addresse.City) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (!answers.Addresse.State) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (!answers.Addresse.PostalCode) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    } else if (!answers.Addresse.Phone) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    } else if (!isEmpty(sharedObject.specialties) && CheckSpecialty()) {
      SetspecialtiesFlag(true);
      return;
    }
    if (
      answers.Addresse?.Phone.replace(/[^0-9]/g, "").substring(0, 10).length <
        10 ||
      answers.Addresse?.Phone.replace(/[^0-9]/g, "").substring(0, 10).length >
        10
    ) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    }
    if (
      answers.Addresse?.Fax !== null &&
      answers?.Addresse?.Fax.length > 0 &&
      (answers?.Addresse?.Fax.replace(/[^0-9]/g, "").substring(0, 10).length <
        10 ||
        answers.Addresse?.Fax.replace(/[^0-9]/g, "").substring(0, 10).length >
          10)
    ) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      return;
    }
    if (answers.XDREnabled) {
      if (answers.xdrConfig === null) {
        SetMsg("Please select an XDR Endpoint");
        SetErrMsg(true);
        return;
      }
      if (answers.xdrConfig.Id === null) {
        SetMsg("Please select an XDR Endpoint");
        SetErrMsg(true);
        return;
      }
    }

    let pExt = answers.Addresse.PhoneExt ? answers.Addresse.PhoneExt : "";
    let fExt = answers.Addresse.FaxExt ? answers.Addresse.FaxExt : "";
    answers.Addresse.Phone =
      answers.Addresse.Phone.replace(/[^0-9]/g, "").substring(0, 10) + pExt;
    answers.Addresse.Fax =
      answers.Addresse.Fax.replace(/[^0-9]/g, "").substring(0, 10) + fExt;
    answers.Addresse.IsCertAddress = true;
    answers.Addresses = [answers.Addresse];
    let vl = answers.DomainBox.split("-");
    answers.DomainId =
      userRole === "SES ADMINISTRATOR" ? vl[0] : userSession.domain_id;
    answers.DomainName =
      userRole === "SES ADMINISTRATOR" ? vl[1] : userSession.domain_name;
    if (customerObj.Type === "sub") {
      let vId = answers.ParentOrg.split("~");
      answers.VendorId = parseInt(vId[2]);
    } else {
      let custVal = answers.VendorVal.split("-");
      answers.VendorId = parseInt(custVal[1]);
    }

    let specCode = null;
    if (answers.specializationCode && answers.specializationCode != "") {
      specCode = answers.specializationCode;
    } else {
      specCode = "Empty";
      answers.Specialties = [];
    }
    if (!isEmpty(answers.NPI)) {
      let obj = {
        RecordId: 0,
        IDType: 0,
        Value: answers.NPI,
        IssuingAuthority: "CMS",
      };
      answers.IDs = [obj];
    }
    var newAnswers = answers;
    newAnswers.VendorVal = answers.VendorVal;
    SetProcessing(true);
    let call =
      "/organization/CreateUpdateOrganization?specializationCode=" + specCode;

    const res = await CallAPI(call, newAnswers, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetColorMsg("success");
      let callOrgs = "/organization/GetOrgs";
      const resOrg = await CallAPI(callOrgs, false, "get", userToken);
      await SetSharedObject("ResponseCode", resOrg.code);
      if (resOrg.status === "SUCCESS") {
        let orgObj = resOrg.data.data;
        SetSharedObject("getOrgsObj", orgObj);
        let oObj = {
          ...answers,
          id: parseInt(res.data.org),
          Name: answers.OrganizationName,
          vendorId: answers.VendorId,
        };
        SetSharedObject("orgActionObjForUser", oObj);
      }
      SetMsg("Organization has been added successfully.");
      SetErrCreateMsg(true);
      SetProcessing(false);

      navigate("/org-registration-success");
    } else if (
      res.status === "SERVERERROR" ||
      res.status === "REGISTRATIONERROR"
    ) {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        SetMsg(msg);
      }
      SetErrCreateMsg(true);
      SetColorMsg("danger");
      SetProcessing(false);
    }
  };
  const userEdit = (obj) => {
    setAnswers({
      ...answers,
      OrganizationName: obj.Name,
      Addresse: obj.Addresses,
      NPI: obj.NPI,
    });
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      Specialties: [val],
      specializationCode: val.Code,
    });
  };
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    //if (customerPermissionsObj.emailForwardingType === 0 && customerPermissionsObj.twoFactorAuth === false && customerPermissionsObj.applicationAccessXDR === false && customerPermissionsObj.applicationAccessENS === false && customerPermissionsObj.directorySharing === false) {
    //    SetNoPermissions(true);
    //} else {
    //    SetNoPermissions(false);
    //}
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObject(tmp);
  };
  const [custId, setCustId] = useState(0);
  const getCustId = async (val) => {
    let call = "/organization/getOrganizationById?orgId=" + val;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res.data.data.organization;
      setCustId(det.vendorId);
    } else if (
      res.status === "SERVERERROR" ||
      res.status === "REGISTRATIONERROR"
    ) {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        SetMsg(msg);
      }
      SetErrCreateMsg(true);
      SetColorMsg("danger");
      SetProcessing(false);
    }
  };
  const [vendorObject, SetVendorObject] = useState([]);
  const getVendorsDomains = async (val, flag) => {
    setAnswer("VendorVal", val);
    if (val === "") return;
    let domId = val.split("-");
    let vl = "";
    let tmp = {};
    let permissionFlag = false;
    sharedObject?.vendorsObj?.map((el) => {
      if (el.id === parseInt(domId[1])) {
        tmp = el;
        if (
          el.emailForwardingType === 0 &&
          el.twoFactorAuth === false &&
          el.applicationAccessXDR === false &&
          el.applicationAccessENS === false &&
          el.directorySharing === false
        ) {
          permissionFlag = true;
        }
      }
    });

    SetNoPermissions(permissionFlag);
    SetCustomerPermissionsObj(tmp);
    SetProcessing(true);
    let call = "/organization/GetVendorDomains?BaseDomanID=" + domId[0];
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let ob = res.data.data;
      const temp = [];
      for (let el of ob) {
        el.show = true;
        if (flag && parseInt(domId[0]) === parseInt(el.value)) {
          vl = el.value + "-" + el.text;
        }
        temp.push(el);
      }
      await setAnswers({
        ...answers,
        DomainBox: vl,
        VendorVal: val,
      });
      SetVendorObject(temp);
    }
    SetProcessing(false);
  };
  const GetXdrConfig = async (vl, flag) => {
    let temp = {};
    for (let el of XdrArr) {
      if (el.id === parseInt(vl)) {
        temp = el;
        break;
      }
    }

    SetSharedObject("xdrSettiingObj", temp);
    let custId = sharedObject.orgActionObj;
    let ob = {
      xdrConfig: temp,
      OutboundXDRConfigName: vl,
    };
    if (flag) {
      ob = {
        ...ob,
        XDREnabled: true,
        ApplicationAccessXDR: custId.applicationAccessXDR,
        ParentOrg: flag,
      };
    }
    SetParentXDRObj(ob);
  };
  const handleXDR = () => {
    GetXdrConfig(answers.xdrConfig.id);
    $("#xdrSettingModal").modal("show");
  };

  const GetDomainsByOrg = async (val, name) => {
    setAnswer("OrganizationKind", "");
    SetCustomerPermissionsObj({});
    if (val === "") return;
    let org = val.split("~");
    let tmp = {};
    let permissionFlag = false;
    sharedObject?.vendorsObj?.map((el) => {
      if (el.id === parseInt(org[2])) {
        tmp = el;
        if (
          el.emailForwardingType === 0 &&
          el.twoFactorAuth === false &&
          el.applicationAccessXDR === false &&
          el.applicationAccessENS === false &&
          el.directorySharing === false
        ) {
          permissionFlag = true;
        }
      }
    });

    SetNoPermissions(permissionFlag);
    SetCustomerPermissionsObj(tmp);

    SetProcessing(true);
    let vl = "";

    let callXDR = "/organization/getXDRConfigByOrgId?orgId=" + org[1];
    const resXDR = await CallAPI(callXDR, false, "get", userToken);
    await SetSharedObject("ResponseCode", resXDR.code);
    if (resXDR.status === "SUCCESS") {
      let id = resXDR?.data?.data?.id;
      if (typeof id !== "undefined" && id !== null) {
        GetXdrConfig(id, val);
      }
      SetSharedObject("xdrSettiingObj", {});
    } else if (resXDR.status === "SERVERERROR") {
      SetProcessing(false);
    }
    if (userRole === "SES ADMINISTRATOR") {
      let call = "/organization/getVendorDomainsByOrg?orgId=" + org[1];
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        SetVendorObject(res.data.data);
        //getCustId(org[1]);
        let ob = res.data.data;
        const temp = [];

        for (let el of ob) {
          el.show = true;
          if (name === el.text) {
            vl = el.value + "-" + el.text;
          }
          temp.push(el);
        }
        SetVendorObject(temp);
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
    }

    let tempObj = {
      AdminCount: 0,
      CredentialText: "",
      DomainBox: "",
      DomainId: 0,
      DomainName: null,
      ExternalId: "",
      IDs: [],
      Id: null,
      IsCertAddress: true,
      IsEpicOrganization: false,
      KeepMDN: false,
      NPI: "",
      OrgEmailCount: 0,
      OrganizationKind: null,
      OrganizationName: "",
      OrganizationType: "",
      OutOfNetwork: false,
      ParentOrg: "",
      ParentOrganizationId: null,
      ParentOrganizationName: null,
      Specialties: [],
      Addresse: {
        FirstLine: "",
        SecondLine: "",
        City: "",
        State: "",
        County: "",
        PostalCode: "",
        Country: "",
        Phone: "",
        PhoneExt: "",
        Fax: "",
        FaxExt: "",
        AddressType: 0,
      },
      SubOrgCount: 0,
      UserCount: 0,
      UserEmailCount: 0,
      VendorId: 0,
      VendorVal: "",
      XDRDoNOTGenerateXDM: false,
      XDREnabled: false,
      xdrConfig: {
        Id: null,
        IsValid: false,
        OrganizationId: null,
        UseConfigFile: false,
        EndpointName: "",
        EndpointAddress: "",
        ClientCertificate: false,
        ClientCertificateFindValue: "",
        SchemaValidatorOn: false,
        SchemaValidateRequest: false,
        SchemaValidateResponse: false,
        MDNForward: false,
      },
      AllowTwoFactor: false,
      ApplicationAccessXDR: false,
      ApplicationAccessENS: false,
      specializationCode: "",
      TwoFactorauth: false,
      EmailForwardingType: 0,
      DirectRoute: false,
      AdvancedDirectRoute: false,
      ShareDirectoryListing: false,
    };
    await setAnswers({
      ...tempObj,
      ParentOrg: val,
      ParentOrganizationId: parseInt(org[1]),
      ParentOrganizationName: org[0],
      DomainBox: vl,
    });
    SetProcessing(false);
  };
  const [DirectRoute, SetDirectRoute] = useState(false);
  const [AdvancedDirectRoute, SetAdvancedDirectRoute] = useState(false);
  const setForwardingType = (type, value) => {
    if (type === "DirectRoute") {
      SetDirectRoute(value);
      if (value === true) {
        setAnswer("EmailForwardingType", 1);
      } else {
        setAnswer("EmailForwardingType", 0);
      }
    } else if (type === "AdvancedDirectRoute") {
      SetAdvancedDirectRoute(value);
      if (value === true) {
        setAnswer("EmailForwardingType", 2);
      } else {
        setAnswer("EmailForwardingType", 0);
      }
    }
  };
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  return (
    <div className="RegistrationOrgForm" id="RegistrationOrgForm">
      <form>
        <div className="form-container">
          {/*NPI*/}
          {/*<label for="">Organization</label>*/}

          {customerObj.OrgType === "top" ? (
            <div className="field-wrapper">
              <label for="VendorVal">Customer</label>
              <span className="filter-container dg-clr">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  onChange={(el) => filterVendors(el.target.value)}
                />
              </span>
              <select
                className="form-control"
                size="5"
                id="VendorVal"
                name="VendorVal"
                value={answers.VendorVal}
                onChange={(el) => {
                  let obj = el.target.value;
                  SetCustomerPermissionsObj(obj);
                  getVendorsDomains(el.target.value);
                }}
              >
                <option
                  value=""
                  onClick={() => {
                    SetNoPermissions(true);
                  }}
                >
                  Select Customer
                </option>
                {custObject.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.baseDomainId + "-" + el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {!answers.VendorVal && frmSubmFlag ? (
                <div className="alert alert-danger">Customer is required.</div>
              ) : null}
            </div>
          ) : null}
          {/*Parent Org*/}
          {customerObj.Type === "sub" ? (
            <div className="field-wrapper">
              <label for="ParentOrg">Parent Organization</label>
              <span className="filter-container dg-clr">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  onChange={(el) => filterOrganiations(el.target.value)}
                />
              </span>
              <select
                size="5"
                className="form-control"
                name="ParentOrg"
                id="ParentOrg"
                value={answers.ParentOrg}
                onChange={(el) => GetDomainsByOrg(el.target.value)}
              >
                <option value="">Select Organization</option>
                {orgObject?.map((el) => {
                  if (el.show)
                    return (
                      <option
                        key={el.id}
                        value={el.name + "~" + el.id + "~" + el.vendorId}
                      >
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {!answers.ParentOrg && frmSubmFlag ? (
                <div className="alert alert-danger">
                  Parent Organization selection is required.
                </div>
              ) : null}
            </div>
          ) : null}
          <Npi userEdit={userEdit} />
          {/*Org Name*/}
          <div className="field-wrapper field-box7 v-top">
            <label for="OrgName">Organization Name</label>
            <input
              className="form-control"
              name="OrganizationName"
              id="OrganizationName"
              value={answers.OrganizationName}
              onChange={(el) => setAnswer("OrganizationName", el.target.value)}
            />
            {!answers.OrganizationName && frmSubmFlag ? (
              <div className="alert alert-danger">Required!</div>
            ) : null}
          </div>
          {/*Org Type*/}
          <div className="field-wrapper field-box8 v-top">
            <label for="OrganizationKind">Organization Type</label>
            <select
              className="form-control"
              name="OrganizationKind"
              id="OrganizationKind"
              value={answers.OrganizationKind}
              onChange={(el) => {
                let val = el.target.value;
                setAnswer("OrganizationKind", parseInt(val));
              }}
            >
              <option value="">Select</option>
              {sharedObject?.getOrgKinds?.map((el) => (
                <option key={el.id} value={el.id}>
                  {el.description}
                </option>
              ))}
            </select>
            {(answers.OrganizationKind === null ||
              answers.OrganizationKind === undefined) &&
            frmSubmFlag ? (
              <div className="alert alert-danger">Required!</div>
            ) : null}
          </div>

          {userRole === "SES ADMINISTRATOR" ? (
            <div className="field-wrapper">
              <label for="DomainBox">Domain</label>
              <select
                className="form-control"
                name="DomainBox"
                id="DomainBox"
                value={answers.DomainBox}
                onChange={(el) => {
                  let val = el.target.value;
                  setAnswer("DomainBox", val);
                }}
              >
                <option value={false}>Select</option>
                {vendorObject.map((el) => (
                  <option key={el.value} value={el.value + "-" + el.text}>
                    {el.text}
                  </option>
                ))}
              </select>
              {!answers.DomainBox && frmSubmFlag ? (
                <div className="alert alert-danger">
                  Domain selection is required.
                </div>
              ) : null}
            </div>
          ) : null}

          {/*Contact Information*/}
          <div className="field-wrapper title-divider">Contact Information</div>
          {/*Address 1*/}
          <div className="field-wrapper field-box2">
            <label for="FirstLine">Address 1</label>
            <input
              className="form-control"
              name="FirstLine"
              id="FirstLine"
              value={answers?.Addresse?.FirstLine}
              onChange={(el) => setAnswer("FirstLine", el.target.value, true)}
            />
            {!answers.Addresse.FirstLine && frmSubmFlag ? (
              <div className="alert alert-danger">Address is required.</div>
            ) : null}
          </div>
          {/*Address 2*/}
          <div className="field-wrapper field-box3">
            <label for="SecondLine">Address 2</label>
            <input
              className="form-control"
              name="SecondLine"
              placeholder="Optional"
              value={answers.Addresse.SecondLine}
              onChange={(el) => setAnswer("SecondLine", el.target.value, true)}
            />
          </div>
          <div className="field-wrapper field-box2">
            <label for="city">City</label>
            <input
              className="form-control"
              name="City"
              id="City"
              value={answers.Addresse.City}
              onChange={(el) => setAnswer("City", el.target.value, true)}
            />
            {!answers.Addresse.City && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger">City is required.</div>
              </div>
            ) : null}
          </div>
          <div className="field-wrapper field-box3">
            <div className="spacer-margin5 spacer-inline field-ext">
              <label for="State">State</label>
              <select
                className="form-control"
                name="State"
                id="State"
                value={answers.Addresse.State}
                onChange={(el) => setAnswer("State", el.target.value, true)}
              >
                <option value="">Select</option>
                {stateCodeArray.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </select>
            </div>
            {/*Zip Code*/}
            <div className="spacer-inline field-ext sp-mx1">
              <label for="PostalCode">Zip</label>
              <input
                className="form-control"
                id="PostalCode"
                name="PostalCode"
                value={answers.Addresse.PostalCode}
                onChange={(el) =>
                  setAnswer("PostalCode", el.target.value, true)
                }
              />
            </div>
            {!answers.Addresse.State && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger">State is required.</div>
              </div>
            ) : null}
            {!answers.Addresse.PostalCode && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger">Zip is required.</div>
              </div>
            ) : null}
          </div>
          {/*Phone*/}
          <div className="field-wrapper ">
            <div className="field-box2">
              <label for="Phone">Phone</label>
              <input
                className="form-control"
                id="Phone"
                name="Phone"
                value={formatPhoneNumber(answers.Addresse.Phone)}
                onChange={(el) => {
                  setAnswer("Phone", el.target.value, true);
                }}
              />
              {!answers.Addresse.Phone && frmSubmFlag ? (
                <div className="alert alert-danger">
                  Phone number is required.
                </div>
              ) : null}
              {answers.Addresse?.Phone &&
              answers.Addresse?.Phone.replace(/[^0-9]/g, "").substring(0, 10)
                .length < 10 &&
              frmSubmFlag ? (
                <div className="alert alert-danger">Invalid Phone Number</div>
              ) : null}
            </div>
            <div className="spacer-inline field-ext v-top">
              <label for="PhoneExt">Ext</label>
              <input
                className="form-control"
                name="PhoneExt"
                maxLength={6}
                value={answers.Addresse.PhoneExt}
                onChange={(el) => {
                  let vl = el.target.value;
                  if (vl.length < 7) {
                    setAnswer("PhoneExt", el.target.value, true);
                  }
                }}
              />
            </div>
          </div>
          {/*Fax*/}
          <div className="field-wrapper">
            <div className="field-box2">
              <label for="Fax">Fax</label>
              <input
                className="form-control"
                name="Fax"
                placeholder="Optional"
                value={formatPhoneNumber(answers.Addresse.Fax)}
                onChange={(el) => {
                  setAnswer("Fax", el.target.value, true);
                }}
              />
              {answers.Addresse?.Fax &&
              answers.Addresse?.Fax.replace(/[^0-9]/g, "").substring(0, 10)
                .length < 10 &&
              frmSubmFlag ? (
                <div className="alert alert-danger">Invalid Fax Number</div>
              ) : null}
            </div>
            <div className="spacer-inline field-ext v-top">
              <label for="FaxExt">Ext</label>
              <input
                className="form-control"
                name="FaxExt"
                maxLength={6}
                onChange={(el) => {
                  let vl = el.target.value;
                  if (vl.length < 7) {
                    setAnswer("FaxExt", el.target.value, true);
                  }
                }}
                value={answers.Addresse.FaxExt}
              />
            </div>
          </div>
          {/*External ID*/}
          <div className="field-wrapper">
            <label for="ExtId">External ID</label>
            <input
              className="form-control"
              name="ExternalId: "
              id="ExternalId: "
              value={answers.ExternalId}
              onChange={(el) => setAnswer("ExternalId", el.target.value)}
              placeholder="Optional"
            />
          </div>
          {/*Specialty*/}
          <div className="field-wrapper title-divider">Specialty</div>
          <div className="field-wrapper descript-container">
            This section is optional but we highly recommend you select these
            options to identify specific areas of focus in the organization.{" "}
            <b className="or-clr">
              If you select a type, then you must select both classification and
              specialization.
            </b>
          </div>
          {/*Specialty Component*/}
          <SpecialtyDropdown
            SpecialFormFields={(el, val) => SpecialFormFields(el, val)}
            codes={orgValues?.codes}
          />
          {specialtiesFlag && frmSubmFlag ? (
            <div className="alert alert-danger" id="SpecialtyId">
              Specialization is required when you are selecting Type or
              Classification.
            </div>
          ) : null}
          {/*Permissions*/}
          {userRole !== "SES ADMINISTRATOR" ? null : (
            <>
              <section>
                <div className="field-wrapper title-divider">Permissions</div>
                <div className="field-wrapper">
                  {/*Two-Factor Enable or Disable*/}
                  {noPermissions === true ? (
                    <div className="sub-catg ctr">
                      There are no permissions for this organization.
                    </div>
                  ) : null}
                  {customerPermissionsObj.twoFactorAuth === true ? (
                    <div>
                      <div className="descript-container">
                        Select the checkbox for the options you want to include
                        for this organization. You can update these settings at
                        any time from the Organization page.
                      </div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="TwoFactorAuth"
                          id="TwoFactorAuth"
                          checked={answers.TwoFactorAuth}
                          value={answers.TwoFactorAuth}
                          onClick={(el) =>
                            setAnswer("TwoFactorAuth", el.target.checked)
                          }
                        />
                        <label>Two Factor Authentication</label>
                        <span>
                          <a
                            href="#twoFactorInfo"
                            data-toggle="collapse"
                            aria-expanded="false"
                            aria-controls="TwoFactorInfo"
                            aria-describedby="Two Factor Information"
                          >
                            {" "}
                            <i className="bi bi-info-circle"></i>{" "}
                          </a>
                        </span>
                      </section>
                      <section className="collapse text-reg" id="twoFactorInfo">
                        Two-factor authentication improves your digital security
                        by protecting your account with an additional login
                        step. It makes it harder for unauthorized users to gain
                        access to an account without permission.
                      </section>
                    </div>
                  ) : null}
                  {/*XDR Access Enable or Disable*/}
                  {customerPermissionsObj.applicationAccessXDR === true ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="ApplicationAccessXDR"
                          id="ApplicationAccessXDR"
                          checked={answers?.ApplicationAccessXDR}
                          value={answers?.ApplicationAccessXDR}
                          onClick={(el) =>
                            setAnswer("ApplicationAccessXDR", el.target.checked)
                          }
                        />
                        <label>XDR-Access</label>
                      </section>
                    </div>
                  ) : null}
                  {/*Notify Enable or Disable*/}
                  {customerPermissionsObj.applicationAccessENS === true ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="ApplicationAccessENS"
                          id="ApplicationAccessENS"
                          checked={answers.ApplicationAccessENS}
                          value={answers.ApplicationAccessENS}
                          onClick={(el) =>
                            setAnswer("ApplicationAccessENS", el.target.checked)
                          }
                        />
                        <label>Notify</label>
                      </section>
                    </div>
                  ) : null}
                  {/*DirectRoute Enable or Disable*/}
                  {customerPermissionsObj.emailForwardingType &&
                  customerPermissionsObj.emailForwardingType === 1 ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="DirectRoute"
                          id="DirectRoute"
                          checked={DirectRoute}
                          value={DirectRoute}
                          onClick={(el) =>
                            setForwardingType("DirectRoute", el.target.checked)
                          }
                          disabled={AdvancedDirectRoute}
                        />
                        <label>DirectRoute</label>
                      </section>
                    </div>
                  ) : null}
                  {customerPermissionsObj.emailForwardingType &&
                  customerPermissionsObj.emailForwardingType === 2 ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="AdvancedDirectRoute"
                          id="AdvancedDirectRoute"
                          checked={AdvancedDirectRoute}
                          value={AdvancedDirectRoute}
                          onClick={(el) =>
                            setForwardingType(
                              "AdvancedDirectRoute",
                              el.target.checked
                            )
                          }
                          disabled={DirectRoute}
                        />
                        <label>Advanced DirectRoute</label>
                      </section>
                    </div>
                  ) : null}

                  {/*Share Directory Listing Enable or Disable*/}
                  {customerPermissionsObj.directorySharing === true ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="ShareDirectoryListing"
                          id="ShareDirectoryListing"
                          checked={answers.ShareDirectoryListing}
                          value={answers.ShareDirectoryListing}
                          onClick={(el) =>
                            setAnswer(
                              "ShareDirectoryListing",
                              el.target.checked
                            )
                          }
                        />
                        <label>Share Directory Listing</label>
                      </section>
                    </div>
                  ) : null}
                </div>
              </section>

              {/*Email Delivery*/}
              <div className="field-wrapper title-divider">Email Delivery</div>
              {answers?.ApplicationAccessXDR === true &&
              customerPermissionsObj.applicationAccessXDR === true ? (
                <>
                  <div>
                    {/*Outbound XDR*/}
                    <div className="field-wrapper">
                      <label for="OutboundXDR">Inbound XDR:</label>
                      <input
                        className="form-control spacer-margin2"
                        name="XDREnabled"
                        type="checkbox"
                        checked={answers.XDREnabled}
                        onChange={(el) =>
                          setAnswer("XDREnabled", el.target.checked)
                        }
                      />
                      <select
                        className="form-control w-lg1 spacer-inline"
                        name="OutboundXDRConfigName"
                        id="OutboundXDRConfigName"
                        value={answers.OutboundXDRConfigName}
                        onChange={(el) => {
                          SetSharedObject("xdrAdded", false);
                          GetXdrConfig(el.target.value);
                        }}
                        disabled={!answers.XDREnabled}
                      >
                        <option value="">
                          Add Or Select XDR Configuration
                        </option>
                        {XdrArr?.map((el) => (
                          <option key={el.id} value={el.id}>
                            {el.endpointName}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        className="btn btn-primary spacer-margin2"
                        onClick={(el) => handleXDR()}
                        data-toggle="modal"
                        disabled={!answers.XDREnabled}
                      >
                        <i className="bi bi-gear"></i>
                      </button>
                    </div>
                  </div>
                </>
              ) : null}
              {customerPermissionsObj.applicationAccessXDR === true ? (
                <div className="field-wrapper">
                  <label for="InboundXDR">Outbound XDR</label>
                  {answers?.ApplicationAccessXDR === true &&
                  customerPermissionsObj.applicationAccessXDR === true ? (
                    <>
                      <div>
                        <section>
                          <input
                            className="form-control spacer-margin5"
                            type="checkbox"
                            name="IsEpicOrganization"
                            id="IsEpicOrganization"
                            checked={answers.IsEpicOrganization}
                            value={answers.IsEpicOrganization}
                            onClick={(el) =>
                              setAnswer("IsEpicOrganization", el.target.checked)
                            }
                          />
                          <span for="InboundXDR" className="label-sub">
                            Create Direct Addresses Automatically
                          </span>
                          <a
                            href="#CreateDirect"
                            data-toggle="collapse"
                            aria-expanded="false"
                            aria-controls="CreateDirect"
                          >
                            {" "}
                            <i className="bi bi-plus-lg sm-icon-container"></i>{" "}
                          </a>
                          <div
                            className="collapse text-reg sub-catg"
                            id="CreateDirect"
                          >
                            Emails are created in the organization according to
                            the certificate used to authenticate the INBOUND
                            connection.
                          </div>
                        </section>
                        {/* <section>
                      <input
                        className="form-control spacer-margin5"
                        type="checkbox"
                        name="OutOfNetwork"
                        id="OutOfNetwork"
                        checked={answers.OutOfNetwork}
                        value={answers.OutOfNetwork}
                        onClick={(el) =>
                          setAnswer("OutOfNetwork", el.target.checked)
                        }
                      />
                      <span for="OutNetwork" className="label-sub">
                        Out of Network
                      </span>
                    </section> */}
                      </div>
                    </>
                  ) : null}
                  <section>
                    <input
                      className="form-control spacer-margin5"
                      type="checkbox"
                      name="XdrDoNOTGenerateXDM"
                      id="XdrDoNOTGenerateXDM"
                      checked={answers.XDRDoNOTGenerateXDM}
                      value={answers.XDRDoNOTGenerateXDM}
                      onClick={(el) =>
                        setAnswer("XDRDoNOTGenerateXDM", el.target.checked)
                      }
                    />
                    <span for="xdmDelivery" className="label-sub">
                      XDM Delivery
                    </span>
                    <a
                      href="#xdmDelivery"
                      data-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="xdmDelivery"
                    >
                      <i className="bi bi-plus-lg sm-icon-container"></i>
                    </a>
                    <div
                      className="collapse text-reg sub-catg"
                      id="xdmDelivery"
                    >
                      If checked, message delivered over XDR will be packaged as
                      Direct message with XDM attachment. Please make sure your
                      recipients can accept and handle XDM.
                    </div>
                  </section>
                </div>
              ) : null}
              <div className="field-wrapper">
                <label for="KeepMDN">Keep MDN:</label>
                <input
                  className="form-control spacer-margin2"
                  type="checkbox"
                  name="KeepMDN"
                  id="KeepMDN"
                  checked={answers.KeepMDN}
                  value={answers.KeepMDN}
                  onClick={(el) => setAnswer("KeepMDN", el.target.checked)}
                />
              </div>

              {errCreateMsg ? (
                <div className={`alert alert-${colorMsg}`}>{msg}</div>
              ) : null}
            </>
          )}
          {/* Registration Action*/}
          <div className="button-register-container text-size4">
            <button
              onClick={(el) => SubmitOrgRegistration()}
              type="button"
              className="btn btn-success"
            >
              Register
            </button>
            <button
              className="btn btn-outline-secondary spacer-margin9"
              type="button"
              onClick={(el) => {
                ResetData();
                SetSharedObject("orgActionObj", false);
                navigate("/Organizations");
              }}
            >
              Cancel
            </button>
            {processing ? <div className="loading"></div> : null}
          </div>
        </div>
      </form>
    </div>
  );
};

export default RegistrationOrgForm;
